<div class="step-page">
	<div class="step-title">
		<div class="row-wrap">
			<div class="row-left">
				<div>
					Integrators Management
				</div>
			</div>
		</div>
	</div>
	<div class="step-content">
		<!-- <div class="search-line" *ngIf="currentIntegrators.length < integrators.length">
			<select name="select-integrator"
				[ngClass]="{'select-greyout': selectedIntegrator===null}"
				[(ngModel)]="selectedIntegrator"
				(ngModelChange)="changeIntegrator()">
				<option [ngValue]="null" disabled>Add an integrator...</option>
				<option *ngFor="let integrator of integrators" [hidden]="integrator.isSelected" [ngValue]="integrator" >{{integrator.nameShort}}</option>
			</select>
			<i class="glyphicons glyphicons-plus-sign" title="Invite this integrator" [ngClass]="{'disabled': !selectedIntegrator}" (click)="addIntegrator()"></i>
		</div> -->
		<div class="table-container">
			<app-common-datagrid
				#integratorTable
				[columns]="columns"
				[rows]="integrators"
				[rowH]="40"
				[columnMode]="'force'"
				[selectionType]="undefined"
				[hidePaging]="true"
				[isPaging]="false"
				[rowClass]="setRowClass"
			></app-common-datagrid>
		</div>
	</div>
</div>

<ng-template #operationsTempl let-row="row">
	<div *ngIf="row.isSelected">
		<button class="button-general button-general-no" title="Uninvite this integrator" (click)="uninviteIntegrator(row)">Uninvite</button>
		<!-- <i class="glyphicons glyphicons-minus-sign" title="Remove the integrator" (click)="removeIntegrator(row)"></i> -->
	</div>
	<div *ngIf="!row.isSelected">
		<button class="button-general button-general-yes" title="Invite this integrator" (click)="inviteIntegrator(row)">Invite</button>
	</div>
</ng-template>
<ng-template #adminUsersTempl let-row="row" let-column="column" let-value="value">
	<div>{{row[column.prop] ? row[column.prop].join(): ''}}</div>
</ng-template>